import useOneM1 from '@aims/shared/shared/use-one-m1';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import CSPage from '../../../components/CSPage';
import CSPageHeader from '../../../components/CSPageHeader';
import Error404 from '../../../components/Error404';
import { updateContactAction } from '../../../redux-store/contacts-store';
import useIsCreating from '../../../shared/use-is-creating';
import useQueryParams from '../../../shared/use-query-params';
import useSingleSomethingA10 from '@aims/shared/shared/use-single-something-a10';
import { contactForAdminQuery } from '../ViewContact/constants';
import { extractContactForAdmin } from '../constants';
import EditContactForm from './EditContactForm';

const { Paragraph } = Typography;
const queryId = 'edit-contact';

function EditContact() {
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const { _id, type } = useParams();
  const query = useQueryParams();

  const fetchResult = useOneM1({
    variables: { _id },
    query: contactForAdminQuery,
    extract: extractContactForAdmin,
    fetchPolicy: 'network-only',
    updateAction: updateContactAction,
    queryId,
    showError: false,
  });
  const contact = useSingleSomethingA10('contacts', _id, queryId);

  useEffect(() => {
    if (contact && (!type || contact.contactType !== type.toUpperCase())) {
      history.replace(
        `/contact/edit/${_id}/${contact.contactType.toLowerCase()}`,
      );
    }
  }, [type, contact, history, _id]);

  const handleBack = useCallback(() => {
    if (query && query.from) {
      history.push(query.from);
    } else {
      history.push('/people');
    }
  }, [query, history]);

  const [createTitle, editTitle] = useMemo(() => {
    if (type == 'contact') {
      return ['Create a Contact', 'Edit Contact'];
    }
    if (type == 'household') {
      return ['Create a Household', 'Edit Household'];
    }
    if (type == 'org') {
      return ['Create an Organization', 'Edit Organization'];
    }
    return [];
  }, [type]);

  const { title } = useIsCreating(
    location,
    contact,
    loading,
    createTitle,
    editTitle,
  );

  if (!type) {
    return (
      <CSPage title="Contacts">
        <Paragraph style={{ fontSize: 16 }}>Loading ...</Paragraph>
      </CSPage>
    );
  }

  if (!['contact', 'household', 'org'].includes(type)) {
    return <Error404 />;
  }

  return (
    <>
      <CSPage title={title}>
        <CSPageHeader
          title={title}
          backActions={[
            <Button
              key="back"
              type="text"
              onClick={handleBack}
              icon={<ArrowLeftOutlined />}
            >
              Back to Contacts
            </Button>,
          ]}
        />
        <EditContactForm
          _id={_id}
          handleCancel={handleBack}
          handleSuccess={() => history.push(`/contact/view/${_id}/dashboard`)}
          contact={contact}
          loading={fetchResult.loading || loading}
          setLoading={setLoading}
          style={{ maxWidth: 500 }}
          queryId={queryId}
          contactType={type.toUpperCase()}
        />
      </CSPage>
      <style jsx>{`
        .delete-box {
          display: flex;
          justify-content: center;
        }
      `}</style>
    </>
  );
}

export default EditContact;
